
import * as React from 'react';
import { IDefaultClickActionHandler, IDefaultClickActionHandlerProps } from '../DefaultClickAction';
import { Facet } from '../../../../models/Facet';
import { IItemCache } from '../../../../models/IItemCacheObserver';
import { ItemOpenUrlAction } from '../../openUrl/OpenUrlAction';
import { openUrlFacet } from '../../../../facets/ItemFacets';

export const openUrlDefaultClickActionHandler: IDefaultClickActionHandler = {
    key: new Facet('openUrlDefaultClickHandler').id,
    evaluate: (itemCache: IItemCache, props: IDefaultClickActionHandlerProps) => {
        const {
            itemKey
        } = props;

        const openUrl = itemCache.demandItemFacet(openUrlFacet, itemKey);

        const action = openUrl ? (
            <ItemOpenUrlAction itemKey={ itemKey } />
        ) : undefined;

        return {
            action: action
        };
    }
};
